class StickyAddToCart {
  constructor() {
    this.stickyCart = document.querySelector('.sticky-add-to-cart');
    this.mainProductForm = document.querySelector('product-form:not(.sticky-product-form)');

    // Detect if this is a bundle product
    this.isBundle = !!window.bundleSelections || !!document.querySelector('.bundle-container');

    // Buscar el input principal de variante de forma más robusta
    // Primero intentar dentro del product-form
    this.mainVariantInput = document.querySelector('product-form:not(.sticky-product-form) input[name="id"]');

    // Si no existe, buscar por el atributo form que apunte al formulario principal
    if (!this.mainVariantInput) {
      const allVariantInputs = document.querySelectorAll('input[name="id"]');
      allVariantInputs.forEach(input => {
        const formId = input.getAttribute('form');
        if (formId && formId.includes('product-form') && !formId.includes('sticky')) {
          this.mainVariantInput = input;
        }
      });
    }

    this.stickyVariantInput = document.querySelector('.sticky-product-form input[name="id"]');
    this.stickySellingPlanInput = document.querySelector('.sticky-selling-plan-id');
    this.threshold = 600;
    this.isVisible = false;

    // Bundle-specific properties
    if (this.isBundle) {
      this.bundleProgressText = document.querySelector('.sticky-add-to-cart__progress');
      this.bundleSubscriptionText = document.querySelector('.sticky-add-to-cart__subscription');
      this.stickyImage = document.querySelector('.sticky-add-to-cart__image-element');
      this.stickyTitle = document.querySelector('.sticky-add-to-cart__title');
    }

    // Store references for cleanup
    this.listeners = [];
    this.observers = [];
    this.boundHandleScroll = this.throttle(this.handleScroll.bind(this), 16);

    if (this.stickyCart) {
      this.init();
    }
  }

  // Cleanup method to remove all event listeners and observers
  cleanup() {
    // Remove scroll listener
    window.removeEventListener('scroll', this.boundHandleScroll);

    // Remove all stored listeners
    this.listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    this.listeners = [];

    // Disconnect all observers
    this.observers.forEach(observer => {
      observer.disconnect();
    });
    this.observers = [];

    // Remove injected styles
    this.removeWidgetStyles();
  }

  // Helper method to add listeners with cleanup tracking
  addListener(element, event, handler) {
    element.addEventListener(event, handler);
    this.listeners.push({ element, event, handler });
  }

  init() {
    this.bindEvents();

    if (this.isBundle) {
      this.initBundleSticky();
    } else {
      this.syncVariantFromMain();
      // Esperar a que Recharge cargue y volver a configurar eventos
      this.waitForRecharge();
    }
  }

  initBundleSticky() {
    // Set initial bundle image and title if available
    if (window.bundleProductImage && this.stickyImage) {
      this.stickyImage.src = window.bundleProductImage;
      this.stickyImage.alt = window.bundleProductTitle || 'Bundle';
    }

    if (window.bundleProductTitle && this.stickyTitle) {
      this.stickyTitle.textContent = window.bundleProductTitle;
    }

    // Show bundle progress text
    if (this.bundleProgressText) {
      this.bundleProgressText.style.display = '';
    }

    // Update display based on current bundle state
    this.updateBundleDisplay();
  }

  waitForRecharge() {
    // Intentar configurar eventos de Recharge múltiples veces
    const attempts = [500, 1000, 2000, 3000];

    attempts.forEach(delay => {
      setTimeout(() => {
        this.setupRechargeListeners();
      }, delay);
    });

    // También observar cambios en el DOM
    const observer = new MutationObserver(() => {
      const rechargeWidget = document.querySelector('.rc-widget');
      if (rechargeWidget) {
        this.setupRechargeListeners();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Store observer for cleanup
    this.observers.push(observer);
  }

  setupRechargeListeners() {
    // Escuchar cambios en el selling plan de Recharge
    const rechargeSellingPlanSelect = document.querySelector('select[name="rc_selling_plan"]');

    if (rechargeSellingPlanSelect && !rechargeSellingPlanSelect.dataset.stickyBound) {
      rechargeSellingPlanSelect.dataset.stickyBound = 'true';
      rechargeSellingPlanSelect.addEventListener('change', () => {
        setTimeout(() => {
          this.syncSellingPlan();
        }, 100);
      });
    }

    // Escuchar cambios en los radio buttons de Recharge
    const rechargeRadios = document.querySelectorAll('.rc-radio');

    rechargeRadios.forEach(radio => {
      if (!radio.dataset.stickyBound) {
        radio.dataset.stickyBound = 'true';
        radio.addEventListener('click', () => {
          setTimeout(() => {
            this.syncSellingPlan();
          }, 150);
        });
      }
    });

    if (rechargeRadios.length > 0) {
    }
  }

  bindEvents() {
    // Handle scroll to show/hide sticky cart
    window.addEventListener('scroll', this.boundHandleScroll);

    // Bundle-specific event listeners
    if (this.isBundle) {
      this.bindBundleEvents();
      return; // Skip regular product event listeners for bundles
    }

    // Escuchar el evento variant:change (disparado por custom.js cuando cambia la variante)
    const variantChangeHandler = () => {
      setTimeout(() => {
        this.syncVariantFromMain();
      }, 50);
    };
    this.addListener(document, 'variant:change', variantChangeHandler);

    // Sincronizar variante cuando cambie en el formulario principal
    if (this.mainVariantInput) {
      // Observar cambios en el atributo value
      const observer = new MutationObserver(() => {
        this.syncVariantFromMain();
      });

      observer.observe(this.mainVariantInput, {
        attributes: true,
        attributeFilter: ['value', 'disabled']
      });

      // Store observer for cleanup
      this.observers.push(observer);

      // También escuchar el evento change
      const changeHandler = () => {
        this.syncVariantFromMain();
      };
      this.addListener(this.mainVariantInput, 'change', changeHandler);
    }

    // Escuchar cambios en los selectores de opciones (Flavor, etc)
    const optionSelects = document.querySelectorAll('select[name^="options["]');
    optionSelects.forEach(select => {
      const selectHandler = () => {
        setTimeout(() => {
          this.syncVariantFromMain();
        }, 100);
      };
      this.addListener(select, 'change', selectHandler);
    });

    // Escuchar cambios en radio buttons de opciones (con formato options[...])
    const optionRadios = document.querySelectorAll('input[type="radio"][name^="options["]');
    optionRadios.forEach(radio => {
      const radioHandler = () => {
        setTimeout(() => {
          this.syncVariantFromMain();
        }, 100);
      };
      this.addListener(radio, 'change', radioHandler);
    });

    // Escuchar cambios en radio buttons de variantes (sin formato options[...])
    // Esto cubre casos como name="Flavor", name="Size", etc.
    const variantRadios = document.querySelectorAll('input[type="radio"][name]:not([name^="options["]):not([name*="rc_"]):not([name="selling_plan"])');
    variantRadios.forEach(radio => {
      // Verificar si el radio está asociado al formulario principal del producto
      const formId = radio.getAttribute('form');
      const isProductRadio = formId && formId.includes('product-form') && !formId.includes('sticky');

      // También verificar si está dentro de variant-selects o product-info
      const inVariantSelects = radio.closest('variant-selects');
      const inProductInfo = radio.closest('product-info');

      if (isProductRadio || inVariantSelects || inProductInfo) {
        const variantRadioHandler = () => {
          setTimeout(() => {
            this.syncVariantFromMain();
          }, 100);
        };
        this.addListener(radio, 'change', variantRadioHandler);
      }
    });

    // Los listeners de Recharge se configuran en waitForRecharge()
  }

  bindBundleEvents() {
    // Listen to bundle selection changes
    const bundleSelectionHandler = (event) => {
      this.updateBundleDisplay(event.detail);
    };
    this.addListener(document, 'bundle:selection-changed', bundleSelectionHandler);

    // Listen to bundle totals changes
    const bundleTotalsHandler = (event) => {
      this.updateBundlePrice(event.detail);
    };
    this.addListener(document, 'bundle:totals-changed', bundleTotalsHandler);

    // Listen to subscription type changes (Subscribe vs Buy Once)
    const purchaseTypeRadios = document.querySelectorAll('.subscription-total__option input[type="radio"]');
    purchaseTypeRadios.forEach(radio => {
      const purchaseTypeHandler = () => {
        this.updateBundleSubscription();
      };
      this.addListener(radio, 'change', purchaseTypeHandler);
    });

    // Listen to subscription plan dropdown changes
    const subscriptionSelect = document.querySelector('.subscription-total__dropdown select');
    if (subscriptionSelect) {
      const subscriptionSelectHandler = () => {
        this.updateBundleSubscription();
      };
      this.addListener(subscriptionSelect, 'change', subscriptionSelectHandler);
    }

    // Handle sticky cart button click for bundles
    const stickyButton = this.stickyCart.querySelector('.sticky-add-to-cart__submit');
    if (stickyButton) {
      const stickyButtonHandler = (e) => {
        e.preventDefault();
        this.handleBundleAddToCart();
      };
      this.addListener(stickyButton, 'click', stickyButtonHandler);
    }
  }

  updateBundleDisplay(detail) {
    // Update component count (X/Y selected)
    if (this.bundleProgressText) {
      const selections = detail?.selectionValues || Object.values(window.bundleSelections || {}).filter(Boolean);
      const totalComponents = document.querySelectorAll('.bundle-dropdown').length;
      const selectedCount = selections.length;

      if (selectedCount === 0) {
        this.bundleProgressText.textContent = `Add ${totalComponents} products`;
      } else if (selectedCount < totalComponents) {
        this.bundleProgressText.textContent = `${selectedCount}/${totalComponents} selected`;
      } else {
        this.bundleProgressText.textContent = 'Bundle complete!';
      }
    }

    // Update button state (enable with 1+ selections)
    const stickyButton = this.stickyCart.querySelector('.sticky-add-to-cart__submit');
    if (stickyButton) {
      const selections = detail?.selectionValues || Object.values(window.bundleSelections || {}).filter(Boolean);
      stickyButton.disabled = selections.length === 0;
    }

    // Update subscription text
    this.updateBundleSubscription();
  }

  updateBundlePrice(totals) {
    // Update price display if we have a price element
    const priceElement = this.stickyCart.querySelector('.sticky-add-to-cart__price');
    if (!priceElement || !totals) return;

    const formatMoney = (cents) => {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
      }
      return `$${(cents / 100).toFixed(2)}`;
    };

    const applyOneTimeDiscount = (amount) => {
      if (!window.bundleOneTimeDiscount) return amount;

      const { discountType, discountValue } = window.bundleOneTimeDiscount;

      if (discountType === 'percentage') {
        return Math.round(amount * (100 - discountValue) / 100);
      } else if (discountType === 'fixed_amount') {
        return Math.max(0, amount - Math.round(discountValue * 100));
      }

      return amount;
    };

    // Show prices if bundle is complete
    if (totals.isComplete) {
      const purchaseType = totals.purchaseType || window.bundlePurchaseType || 'subscribe';
      let oldPrice = null;
      let newPrice = null;

      if (purchaseType === 'subscribe') {
        // Subscribe: show discount from subscription plan
        if (totals.discountPercent > 0 && totals.discountedTotal < totals.subtotal) {
          oldPrice = totals.subtotal;
          newPrice = totals.discountedTotal;
        } else {
          newPrice = totals.discountedTotal || totals.subtotal;
        }
      } else {
        // Buy Once: apply one-time discount if configured
        const basePrice = totals.subtotal;
        const discountedPrice = applyOneTimeDiscount(basePrice);

        // Show old price if there's a discount
        if (discountedPrice < basePrice) {
          oldPrice = basePrice;
          newPrice = discountedPrice;
        } else if (totals.compareSubtotal > totals.subtotal) {
          // Fallback to compare-at-price discount if no one-time discount
          oldPrice = totals.compareSubtotal;
          newPrice = totals.subtotal;
        } else {
          newPrice = totals.subtotal;
        }
      }

      // Display prices
      if (oldPrice && newPrice && oldPrice > newPrice) {
        priceElement.innerHTML = `
          <span class="price-item price-item--sale">
            <span class="price-item__old">${formatMoney(oldPrice)}</span>
            <span class="price-item__current">${formatMoney(newPrice)}</span>
          </span>
        `;
      } else {
        priceElement.innerHTML = `<span class="price-item__current">${formatMoney(newPrice)}</span>`;
      }
      priceElement.hidden = false;
    } else {
      priceElement.hidden = true;
    }
  }

  updateBundleSubscription() {
    if (!this.bundleSubscriptionText) return;

    // Check if Subscribe is selected
    const subscribeRadio = document.getElementById('subscribe-option');
    const isSubscribe = subscribeRadio?.checked;

    if (isSubscribe) {
      // Get the selected plan frequency
      const subscriptionSelect = document.querySelector('.subscription-total__dropdown select');
      if (subscriptionSelect && subscriptionSelect.selectedIndex >= 0) {
        const selectedOption = subscriptionSelect.options[subscriptionSelect.selectedIndex];
        const planText = selectedOption.text || '';
        this.bundleSubscriptionText.textContent = planText;
        this.bundleSubscriptionText.style.display = '';
      }
    } else {
      // Buy Once selected - hide subscription text
      this.bundleSubscriptionText.style.display = 'none';
    }
  }

  handleBundleAddToCart() {
    // Trigger the main add to cart button click
    const mainAddToCartButton = document.querySelector('product-form:not(.sticky-product-form) button[type="submit"]');
    if (mainAddToCartButton && !mainAddToCartButton.disabled) {
      mainAddToCartButton.click();
    }
  }

  syncVariantFromMain() {
    if (!this.mainVariantInput || !this.stickyVariantInput) {
      return;
    }

    // Copiar el variant ID y el estado disabled
    this.stickyVariantInput.value = this.mainVariantInput.value;
    this.stickyVariantInput.disabled = this.mainVariantInput.disabled;

    // Actualizar el botón del sticky cart
    const stickyButton = this.stickyCart.querySelector('.sticky-add-to-cart__submit');
    if (stickyButton) {
      stickyButton.disabled = this.mainVariantInput.disabled;
    }

    // También sincronizar el selling plan
    this.syncSellingPlan();

    // Actualizar la imagen del sticky cart
    this.updateStickyImage(this.mainVariantInput.value);

    // Actualizar el texto de suscripción del sticky cart
    this.updateSubscriptionText();
  }

  syncSellingPlan() {
    if (!this.stickySellingPlanInput) {
      return;
    }

    // Verificar si está seleccionada la suscripción
    const subscriptionRadio = document.querySelector('.rc-radio.subscription-radio.rc-radio--active');

    if (subscriptionRadio) {
      // Suscripción seleccionada - obtener el selling plan ID
      const sellingPlanSelect = document.querySelector('select[name="rc_selling_plan"]');

      if (sellingPlanSelect && sellingPlanSelect.value) {
        this.stickySellingPlanInput.value = sellingPlanSelect.value;
      }
      this.syncRechargeFields();
    } else {
      // ONE-TIME purchase - vaciar el selling plan
      this.stickySellingPlanInput.value = '';

      // Remover campos adicionales de Recharge
      this.removeRechargeFields();
    }

    // Actualizar el texto de suscripción
    this.updateSubscriptionText();
  }

  syncRechargeFields() {
    const mainForm = this.mainProductForm?.querySelector('form');
    const stickyForm = this.stickyCart.querySelector('form');

    if (!mainForm || !stickyForm) {
      return;
    }

    // Buscar todos los inputs de Recharge en el formulario principal
    const rechargeInputs = mainForm.querySelectorAll('input[name^="rc_"], input[name*="recharge"], input[name="selling_plan"]');

    rechargeInputs.forEach(input => {

      // Verificar si ya existe en el sticky form
      let stickyInput = stickyForm.querySelector(`input[name="${input.name}"]`);

      if (!stickyInput) {
        // Crear el input si no existe
        stickyInput = document.createElement('input');
        stickyInput.type = 'hidden';
        stickyInput.name = input.name;
        stickyInput.classList.add('rc-synced-field');
        stickyForm.appendChild(stickyInput);
      }

      // Copiar el valor
      stickyInput.value = input.value;
    });

    // También buscar en todo el DOM por si Recharge usa un contenedor diferente
    const allRechargeInputs = document.querySelectorAll('input[name^="rc_"], input[name*="recharge"], input[name="selling_plan"]');
    allRechargeInputs.forEach(input => {
    });
  }

  removeRechargeFields() {
    const stickyForm = this.stickyCart.querySelector('form');
    if (!stickyForm) return;

    // Remover campos sincronizados de Recharge
    const syncedFields = stickyForm.querySelectorAll('.rc-synced-field');
    syncedFields.forEach(field => field.remove());
  }

  updateStickyImage(variantId) {
    const stickyImage = document.querySelector('.sticky-add-to-cart__image-element');
    if (!stickyImage) return;

    const stickyCart = document.querySelector('.sticky-add-to-cart');
    const sectionId = stickyCart?.getAttribute('data-section-id');
    if (!sectionId) return;

    const variantDataScript = document.querySelector(`#sticky-variant-data-${sectionId}`);
    if (!variantDataScript) return;

    try {
      const variantData = JSON.parse(variantDataScript.textContent);
      const variant = variantData.variants[variantId];

      if (variant && variant.image && variant.image.src) {
        // Asegurar que la URL tenga el protocolo correcto
        let imageSrc = variant.image.src;
        if (imageSrc.startsWith('//')) {
          imageSrc = 'https:' + imageSrc;
        }

        // Forzar recarga de la imagen agregando timestamp para evitar caché
        const timestamp = new Date().getTime();
        const separator = imageSrc.includes('?') ? '&' : '?';
        const imageWithTimestamp = `${imageSrc}${separator}_t=${timestamp}`;

        // Actualizar src y srcset
        stickyImage.src = imageWithTimestamp;
        stickyImage.srcset = imageWithTimestamp;
        stickyImage.alt = variant.image.alt;
      }
    } catch (error) {
      console.error('[Sticky] Error updating image:', error);
    }
  }

  updateSubscriptionText() {
    const stickySubscriptionElement = document.querySelector('.sticky-add-to-cart__subscription');
    if (!stickySubscriptionElement) return;

    // Verificar si está seleccionada la suscripción
    const subscriptionRadio = document.querySelector('.rc-radio.subscription-radio.rc-radio--active');

    if (subscriptionRadio) {
      // Suscripción seleccionada - obtener el texto del plan
      const sellingPlanSelect = document.querySelector('select[name="rc_selling_plan"]');

      if (sellingPlanSelect) {
        const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
        const selectedText = selectedOption?.text || '';

        // Parsear el texto (ej: "60 day subscription with 25% discount" → "Deliver every 8 weeks")
        const displayText = this.parseSubscriptionText(selectedText);
        stickySubscriptionElement.textContent = displayText;
        stickySubscriptionElement.style.display = '';
      }
    } else {
      // ONE-TIME purchase - mostrar el título de la variante
      const variantId = this.mainVariantInput?.value;
      if (variantId) {
        const variantTitle = this.getVariantTitle(variantId);
        if (variantTitle) {
          stickySubscriptionElement.textContent = variantTitle;
          stickySubscriptionElement.style.display = '';
        } else {
          stickySubscriptionElement.style.display = 'none';
        }
      } else {
        stickySubscriptionElement.style.display = 'none';
      }
    }
  }

  getVariantTitle(variantId) {
    const stickyCart = document.querySelector('.sticky-add-to-cart');
    const sectionId = stickyCart?.getAttribute('data-section-id');
    if (!sectionId) return '';

    const variantDataScript = document.querySelector(`#sticky-variant-data-${sectionId}`);
    if (!variantDataScript) return '';

    try {
      const variantData = JSON.parse(variantDataScript.textContent);
      const variant = variantData.variants[variantId];
      return variant?.title || '';
    } catch (error) {
      return '';
    }
  }

  parseSubscriptionText(text) {
    // Intentar obtener la información directamente del dropdown de Recharge
    const rechargeDropdown = document.querySelector('.rc-selling-plans-dropdown__select, select[name="rc_selling_plan"]');

    if (rechargeDropdown && rechargeDropdown.selectedIndex >= 0) {
      const selectedOption = rechargeDropdown.options[rechargeDropdown.selectedIndex];
      const optionText = selectedOption?.text || '';

      // Usar el texto del dropdown directamente
      if (optionText) {
        return optionText;
      }
    }

    // Fallback: parsear el texto pasado como parámetro
    if (!text) return '';

    // Retornar el texto tal cual viene de Recharge
    return text;
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const shouldShow = scrollY > this.threshold && this.shouldShowStickyCart();

    if (shouldShow && !this.isVisible) {
      this.show();
    } else if (!shouldShow && this.isVisible) {
      this.hide();
    }
  }

  shouldShowStickyCart() {
    // For bundles, also check if at least one component is selected
    if (this.isBundle) {
      const selections = Object.values(window.bundleSelections || {}).filter(Boolean);
      if (selections.length === 0) {
        return false;
      }
    }

    const mainAddToCartButton = document.querySelector('product-form:not(.sticky-product-form) [type="submit"]');

    if (mainAddToCartButton) {
      const rect = mainAddToCartButton.getBoundingClientRect();
      const isMainButtonVisible = rect.bottom > 0;
      return !isMainButtonVisible;
    }
    return true;
  }

  show() {
    this.isVisible = true;
    this.stickyCart.classList.add('is-visible', 'animate-in');
    this.stickyCart.classList.remove('animate-out');
    this.applyWidgetStyles();
  }

  hide() {
    this.isVisible = false;
    this.stickyCart.classList.add('animate-out');
    this.stickyCart.classList.remove('is-visible', 'animate-in');
    this.removeWidgetStyles();
  }

  applyWidgetStyles() {
    if (window.innerWidth <= 480) {
      this.injectWidgetStyles();
    }
  }

  injectWidgetStyles() {
    const existingStyle = document.getElementById('sticky-cart-widget-styles');
    if (existingStyle) {
      existingStyle.remove();
    }
    const style = document.createElement('style');
    style.id = 'sticky-cart-widget-styles';
    style.textContent = `
      @media only screen and (max-width: 480px) {
        access-widget-ui::part(acsb-trigger) {
          bottom: 80px !important;
          transform: translateY(-100%) !important;
        }
        
        .gorgias-chat-key-1vly0ou {
          bottom: 94px !important;
          right: 5px !important;
        }
        [class*="gorgias-chat"] {
          bottom: 94px !important;
          right: 5px !important;
        }
        access-widget-ui {
          --acsb-trigger-bottom: 80px !important;
        }
      }
    `;
    
    // Agregar al head del documento
    document.head.appendChild(style);
  }

  removeWidgetStyles() {
    // Remover los estilos CSS inyectados
    const existingStyle = document.getElementById('sticky-cart-widget-styles');
    if (existingStyle) {
      existingStyle.remove();
    }
  }

  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
}

// Singleton instance
let stickyAddToCartInstance = null;

// Initialize function with cleanup
function initializeStickyAddToCart() {
  // Cleanup previous instance if it exists
  if (stickyAddToCartInstance) {
    stickyAddToCartInstance.cleanup();
    stickyAddToCartInstance = null;
  }

  // Create new instance
  stickyAddToCartInstance = new StickyAddToCart();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeStickyAddToCart();
  });
} else {
  initializeStickyAddToCart();
}

// Re-initialize on page transitions
document.addEventListener('shopify:section:load', () => {
  initializeStickyAddToCart();
});